import React, { useState, useRef, useEffect } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import EmojiPicker from 'emoji-picker-react'
import IonIcon from '@reacticons/ionicons'
import { chatagent } from '../../services/data'
import { toast } from 'react-toastify'
import '../../styles/replytexteditor.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTurnDown } from '@fortawesome/free-solid-svg-icons'
import Loader from '../../components/loader'
import { GetSettingsticketimap } from '../../services/data'
import console_log from '../../util/consolelog'
import { useLocation, useParams } from 'react-router-dom'

const ReplyTextEditor = ({ ticket_id }) => {
  const [editorValue, setEditorValue] = useState('')
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const quillRef = useRef(null)
  const emojiPickerRef = useRef(null)
  const [savedCursor, setSavedCursor] = useState(null)
  const [shownotify, setshownotify] = useState(true)
  const [loading, setLoading] = useState(false)
  const [configType, setConfigType] = useState(null)
  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const store_id = getStoreIdFromUrl()

  useEffect(() => {
    if (window.location.pathname === '/chats') {
      setshownotify(false)
    }
  }, [])

  useEffect(() => {
    const fetchIMAPConfig = async () => {
      const response = await GetSettingsticketimap(store_id)
      setConfigType(response?.data?.type)
    }

    fetchIMAPConfig()
  }, [])

  const handleEmojiClick = emojiObject => {
    const editor = quillRef.current?.getEditor()
    if (!editor) return

    editor.focus()
    let range = editor.getSelection()
    let cursorPosition =
      range && range.index !== null ? range.index : editor.getLength()

    editor.insertText(cursorPosition, emojiObject.emoji)
    setEditorValue(editor.root.innerHTML)

    editor.setSelection(cursorPosition + emojiObject.emoji.length)
    setSavedCursor(cursorPosition + emojiObject.emoji.length)
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target) &&
        !event.target.closest('.emoji-btn')
      ) {
        setShowEmojiPicker(false)
      }
    }

    if (showEmojiPicker) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showEmojiPicker])

  const handlePassAgent = async () => {
    const quill = quillRef.current?.getEditor()
    let htmlText = quill ? quill.root.innerHTML.trim() : ''

    htmlText = htmlText.replace(/<p><br\s*\/?><\/p>/g, '').trim()
    while (/<(strong|em|u|span)[^>]*>\s*<\/\1>/g.test(htmlText)) {
      htmlText = htmlText
        .replace(/<(strong|em|u|span)[^>]*>\s*<\/\1>/g, '')
        .trim()
    }

    const plainText = htmlText.replace(/<\/?[^>]+(>|$)/g, '').trim()
    if (!plainText) return

    const notifyCheckbox = document.querySelector("input[name='notify']")
    const data = {
      message: htmlText,
      store_id: store_id,
      customer_id: localStorage.getItem('chatlog_customer_id'),
      chat_id: localStorage.getItem('chatlist_customer_id'),
      ticket_id: ticket_id,
      ...(notifyCheckbox?.checked ? { notify: true } : { notify: false })
    }

    try {
      setLoading(true)
      const res = await chatagent(data)
      if (res.success) {
        window.dispatchEvent(
          new CustomEvent('chatagent', {
            detail: { message: res.message, success: true }
          })
        )
        setEditorValue('')
      } else {
        toast.error(res.message, { position: 'bottom-center' })
      }
    } catch (err) {
      toast.error('An error occurred', { position: 'bottom-center' })
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = event => {
    if (event.ctrlKey && event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handlePassAgent()
    }
  }

  const handleEditorChange = (content, delta, source, editor) => {
    const range = editor.getSelection()
    if (source === 'user') {
      setEditorValue(editor.getHTML())
    }
    if (range) {
      setSavedCursor(range.index)
    }
  }

  const modules = {
    toolbar: {
      container: '#toolbar'
    }
  }

  return (
    <div className='w-full flex bg-white relative'>
      <div className='relative w-full'>
        <div className='flex gap-2 items-center'>
          <ReactQuill
            ref={quillRef}
            theme='snow'
            placeholder='Type your message...'
            style={{ width: '100%' }}
            modules={modules}
            value={editorValue}
            onChange={handleEditorChange}
            onKeyDown={handleKeyDown}
          />
          <button
            disabled={loading}
            className={`px-3 py-[10px] rounded-md flex items-center justify-center gap-2 bg-[#7c49eb] text-white ${
              loading ? 'opacity-60 cursor-not-allowed' : ''
            }`}
            onClick={handlePassAgent}
          >
            {loading ? (
              <Loader size={22} />
            ) : (
              <IonIcon
                name='send-outline'
                className='font-bold text-white text-xl'
              />
            )}
            <span className='text-[10px] font-medium opacity-80 flex items-center'>
              <span className='text-white'>Ctrl</span>
              <span className='ml-1'>+</span>
              <span className='ml-1'>
                <FontAwesomeIcon icon={faTurnDown} className='rotate-90' />
              </span>
            </span>
          </button>
        </div>

        <div className=''>
          {showEmojiPicker && (
            <div
              ref={emojiPickerRef}
              className='fixed right-[20%] top-[10%] z-50 bg-white shadow-xl ring-4 ring-gray-300 w-auto max-w-[380px] max-h-[350px] overflow-y-auto rounded-lg'
            >
              <div className='sticky top-0 bg-white w-full p-2 flex justify-end'>
                <button
                  className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px] text-[14px] sm:text-[18px] cursor-pointer'
                  onClick={() => setShowEmojiPicker(false)}
                >
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 30 30'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M9.10041 7.77459C8.7343 7.40847 8.1407 7.40847 7.77459 7.77459C7.40847 8.1407 7.40847 8.7343 7.77459 9.10041L13.6742 15L7.77459 20.8996C7.40847 21.2657 7.40847 21.8593 7.77459 22.2254C8.1407 22.5915 8.7343 22.5915 9.10041 22.2254L15 16.3258L20.8996 22.2254C21.2657 22.5915 21.8593 22.5915 22.2254 22.2254C22.5915 21.8593 22.5915 21.2657 22.2254 20.8996L16.3258 15L22.2254 9.10041C22.5915 8.7343 22.5915 8.1407 22.2254 7.77459C21.8593 7.40847 21.2657 7.40847 20.8996 7.77459L15 13.6742L9.10041 7.77459Z'
                      fill='#373737'
                    ></path>
                  </svg>
                </button>
              </div>
              <EmojiPicker onEmojiClick={handleEmojiClick} className='-z-50' />
            </div>
          )}
          {/* statement */}
          <div>
            {configType === 'notify_only' && (
              <p className='text-[12px] text-gray-500 mt-1'>
                <span className='text-red-500 text-base mr-1'>*</span>
                Note: Your reply will be sent as a notification to the customer.
              </p>
            )}
            {configType === 'imap' && (
              <p className='text-[12px] text-gray-500 mt-1'>
                <span className='text-red-500 text-base mr-1'>*</span>
                Note: Your reply will be delivered directly to the customer's
                inbox.
              </p>
            )}
            {!configType && (
              <p className='text-[12px] text-gray-500 mt-1'>
                <span className='text-red-500 text-base mr-1'>*</span>
                Important: No configuration type is selected. Please choose a
                reply method to ensure that your messages are delivered
                correctly. Selecting a proper configuration will allow the
                system to notify the customer or send the reply directly to
                their inbox, depending on your choice.{' '}
                <button
                  onClick={() =>

                    window.dispatchEvent(new CustomEvent('openSettings'))
                  }
                  className='text-blue-600 hover:underline font-medium ml-1'
                >
                  Open Settings
                </button>
              </p>
            )}
          </div>

          <div className='flex flex-col'>
            <div id='toolbar' className='flex gap-2'>
              <button className='ql-bold' />
              <button className='ql-italic' />
              <button className='ql-underline' />
              {/* <button className='ql-link' /> */}
              <button
                className='emoji-btn'
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              >
                😀
              </button>
            </div>

            {shownotify && (
              <div className='flex items-center w-full gap-1 px-4 mb-2'>
                {/* Optionally enable this:
                <input type='checkbox' name='notify' />
                <p className='text-[#000] text-[13px] font-normal'>
                  Send a notification to the customer
                </p> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReplyTextEditor
